export { PricePage as default } from '@/components/pages/Ir/Stock/Price'
